<template>
    <main class="support">
        <primary-navigation />
        <nav>
            <div class="constrain bc flex flex-align">
                <a class="destination" @click="tab('about')" :class="{active: active === 'about'}">About</a>
                <!-- <a class="destination" @click="tab('instructors')" :class="{active: active === 'instructors'}">For Instructors</a>
                <a class="destination" @click="tab('students')" :class="{active: active === 'students'}">For Students</a> -->
                <div class="ff"></div>
            </div>
        </nav>
        <article class="constrain bc">
            <section v-if="active === 'about'">
                <h1>
                    Starry Night College Textbook&trade; on the SimCur Interactive Learning Platform
                </h1>
                <p>
                    Starry Night College Textbook&trade; expands on OpenStax&trade; Astronomy digital textbook and
                    seamlessly integrates a fully interactive planetarium, engaging simulations, assignable exercises,
                    and a whole universe for your class to explore.
                </p>
                <p>
                    Students are free to explore and experiment, manipulating the fabric of the universe as never
                    before. Our web-based Learning Platform is accessible on most devices to allow learning to happen
                    from anywhere at anytime.
                </p>
                <p>
                    Starry Night College Textbook&trade; integrates with all major Learning Management Systems (LMS),
                    making it easy for instructors to implement and for students to access. The built-in interactive
                    exercises and assessments synch with your LMS grade-book so you can monitor each student’s learning
                    and progress.
                </p>
                <p>
                    Stunning visualizations and engaging exercises place your students anywhere in known space,
                    dynamically showing the solar system, stars, galaxies, and much more - from the distant past to far
                    into the future.
                </p>
                <p>
                    Since 2004, Starry Night has been a key component of most traditional astronomy 101 textbooks. Now,
                    at long last, the awesome power of the world’s leading astronomy education software comes to
                    OpenStax's digital textbook!
                </p>


                <h2>
                    What Makes Starry Night College Textbook&trade; Great
                </h2>
                <p>
                    Starry Night College Textbook&trade; helps you teach a more satisfying course by making it easy for
                    your students to visually grasp important concepts of astronomy that a traditional textbook alone
                    cannot teach.
                </p>
                <ul>
                    <li>
                        <b>Online Planetarium.</b> The integrated Starry Night browser-based planetarium gives you a
                        powerful, accurate, customizable tool to inspire and engage your students. Starry Night models
                        the universe, placing you anywhere at any time.
                    </li>
                    <li>
                        <b>Assignments.</b> More than 75 assignable astronomy exercises, providing endless interactions.
                        The exercises are seamlessly integrated and correlated to the OpenStax&trade; Astronomy
                        textbook.
                    </li>
                    <li>
                        <b>Astronomy 101 Textbook.</b> Access the OpenStax&trade; Astronomy textbook directly on our
                        Interactive Learning Platform. This provides a tight integration between the textbook, the
                        Starry Night browser-based planetarium, and the assignable exercises. It’s the interactive
                        textbook you always dreamed of having.
                    </li>
                    <li>
                        <b>Embedded Simulations.</b> We enhanced the OpenStax&trade; Astronomy textbook with hundreds of
                        inline simulations that bring the concepts on the page to life. Why only read about it, when you
                        can simulate it.
                    </li>
                    <li>
                        <b>Chapter Quizzes.</b> Over 1000 multiple choice questions that encourage students to apply
                        their understanding of the material. The questions for each chapter are organized by section.
                    </li>
                    <li>
                        <b>Anytime, Anywhere, On Any Device.</b> Runs on your web browser and is accessible on most
                        devices including desktop computers, Chromebooks, and tablets.
                    </li>
                    <li>
                        <b>Up to Date.</b> New discoveries, the latest science, and topical space &amp; astronomy events
                        are made available promptly. Your students can view and interact with the newest comets, space
                        probes, planetary images, and more. You no longer have to work with out-of-date print textbooks,
                        waiting years for a new edition to be updated.
                    </li>
                    <li>
                        <b>Free for Instructors.</b> Access is free for professors and instructors with commitment that
                        Starry Night College Textbook&trade; is a required course material for students.
                    </li>
                    <li>
                        <b>Affordable for Students.</b> Our Interactive Learning Platform provides a complete and rich
                        Astronomy 101 textbook combined with dozens of interactive and engaging exercises and
                        simulations. A one-year license is only $29.95 for students.
                    </li>
                    <li>
                        <b>We’re Here for You.</b> Our dedicated Support Team is there to help with anything you might
                        need to make your course successful. From free training on how to use the Starry Night College
                        Textbook&trade; and walking your LMS Administrator through integration - to help resolve any
                        pesky technical issues that cross your way.
                    </li>
                </ul>

                <h1>Anatomy & Physiology Textbook&trade; on the SimCur Interactive Learning Platform</h1>
                <p>
                    Anatomy & Physiology Textbook seamlessly integrates a 28-chapter Anatomy 101 textbook, engaging
                    virtual 3D simulations, assignable exercises, and a new way for students to learn about the human
                    body by manipulating medically accurate 3D anatomical models.
                </p>
                <p>
                    Technically well done and artistically beautiful, our interactive 3D experiences, help students
                    develop a deeper level of learning. And because our Learning Platform is web-based, it is accessible
                    on most devices to allow learning to happen from anywhere at anytime.
                </p>
                <p>
                    Anatomy & Physiology integrates with all major Learning Management Systems (LMS), making it easy for
                    instructors to implement and for students to access. The built-in interactive exercises and
                    assessments synch with your LMS grade-book so you can monitor each student’s learning and progress.
                </p>
                <h2>What Makes Anatomy & Physiology Textbook Great</h2>
                <p>
                    Anatomy & Physiology Textbook helps you teach a more satisfying course by making it easy for your
                    students to visually grasp important concepts of anatomy that a traditional textbook alone cannot
                    teach.
                </p>
                <ul>
                    <li>
                        <b>Assignments.</b> More than 60 assignable virtual anatomy exercises, providing engaging
                        interactions.
                        The exercises are seamlessly integrated and correlated to the open-source OpenStax Anatomy &
                        Physiology textbook.
                    </li>
                    <li>
                        <b>Anatomy 101 Textbook.</b> Access the OpenStax Anatomy & Physiology textbook directly on our
                        Interactive Learning Platform. This provides a tight integration between the textbook, the
                        simulations, and the assignable exercises. It’s the interactive textbook you always dreamed of
                        having.
                    </li>
                    <li>
                        <b>Graded Quizzes.</b> Over 1000 multiple choice questions that encourage students to apply
                        their
                        understanding of the material. The questions for each chapter are organized by section.
                    </li>
                    <li>
                        <b>Anytime, Anywhere, On Any Device.</b> Runs on your web browser and is accessible on most
                        devices
                        including desktop computers, Chromebooks, and tablets.
                    </li>
                    <li>
                        <b>Free for Instructors.</b> Access is free for professors and instructors with commitment that
                        Anatomy
                        & Physiology Textbook is a required course material for students.
                    </li>
                    <li>
                        <b>Affordable for Students.</b> Our Interactive Learning Platform provides a complete and rich
                        Anatomy
                        101 textbook combined with dozens of interactive and engaging exercises and simulations. A
                        one-year license is only $29.95 for students.
                    </li>
                    <li>
                        <b>We’re Here for You.</b> Our dedicated Support Team is there to help with anything you might
                        need to
                        make your course successful. From free training on how to use the Anatomy & Physiology Textbook
                        and walking your LMS Administrator through integration - to help resolve any pesky technical
                        issues that cross your way.
                    </li>
                </ul>

                <h2>Topics Covered</h2>
                <ul>
                    <li>Structural Organization of the Human Body</li>
                    <li>Cellular and Tissue Level Organization</li>
                    <li>Integumentary System</li>
                    <li>Skeletal System, Fractures and Bone Repair</li>
                    <li>Joints</li>
                    <li>Muscular System</li>
                    <li>Nervous System</li>
                    <li>Endocrine System</li>
                    <li>Fluids and Transport</li>
                    <li>Heart Anatomy and the Cardiovascular System</li>
                    <li>Immune System</li>
                    <li>Respiratory and Digestive Systems</li>
                    <li>Urinary System and Body Fluids</li>
                    <li>Reproductive System</li>
                    <li>And More!</li>
                </ul>

                <h2>
                    Learning Management System (LMS) Integration
                </h2>
                <p>
                    Our Interactive Learning Platform integrates with your preferred LMS such as Canvas, Blackboard,
                    Moodle, G Suite (Google Classroom), Microsoft Teams, Brightspace (D2L), and more.
                </p>
                <ul>
                    <li>
                        <b>Single Sign-On.</b> We automatically recognize the roster information already present in your
                        school LMS. Students and Instructors log in with their existing LMS credentials.
                    </li>
                    <li>
                        <b>Assign Content to the LMS.</b> Instructors can assign exercises from the Starry Night College
                        Textbook&trade; directly to their LMS courses.
                    </li>
                    <li>
                        <b>Sync Grades With the LMS.</b> Results from assessments, quizzes and homework assignments are
                        automatically imported from the Starry Night College Textbook&trade; back into your LMS for use
                        by instructors in grading student performance.
                    </li>
                </ul>
            </section>
            <h2>
                Get In Touch
            </h2>
            <div class="contact-form">
                <iframe width="100%" height="800" allowTransparency="true" frameborder="0" scrolling="no"
                    style="border:none" src="https://www.emailmeform.com/builder/embed/f464S2c2va0cdKdJ7"><a
                        href="https://www.emailmeform.com/builder/embed/f464S2c2va0cdKdJ7">Fill out form.</a></iframe>
            </div>
        </article>
    </main>
</template>

<script>
export default {
    name: 'About',
    data() {
        return {
            active: 'about'
        };
    },
    methods: {
        tab(tab) {
            this.active = tab;
        }
    }
}
</script>

<style scoped lang="less">
@import "~@/assets/less/variables";

nav {
    border-bottom: 1px solid var(--border-color);
}

h1 {
    color: var(--primary-text-color);
    margin: 80px 0;
}

h2 {
    color: var(--primary-text-color);
    margin-left: 0;
    margin-right: 0;
}

p,
ul {
    font-size: 15px;
    color: var(--secondary-text-color);
    line-height: 20px;
    margin: 30px 0;
}

article {
    padding-bottom: 100px;
}

li {
    b {
        color: var(--primary-text-color);
    }
}

.contact-form {
    border-radius: 3px;
    background: @f;
    padding: 0 20px;
    margin-top: 20px;
}
</style>
